import ClientLineItem from '../Domain/ClientLineItem';
import serviceHelper from '../Helpers/serviceHelper';
import AuthService from './authService';

export default class ClientLineItemService {
  static GetById(id) {
    let authService = AuthService.getInstance();
    let url = '/api/ClientLine/GetByIdAsync/' + id;
    return authService.CallBackendFunction(url);
  }

  static ConvertDBItems(itemlist) {
    let mappedItems = [];

    if (itemlist !== null) {
      mappedItems = itemlist.map((item) => new ClientLineItem(item));
    }

    return mappedItems;
  }

  static EditClientLineItem(item) {
    item = serviceHelper.ConvertAllPropertyToString(item);
    let url = '/api/ClientLine/EditClientLineAsync';

    return AuthService.getInstance().CallBackendFunctionPut(url, JSON.stringify(item));
  }

  static RemoveLineItemsFromClientInvoice(removeItem) {
    return AuthService.getInstance().CallBackendFunctionPost(
      '/api/ClientLine/RemoveLineItemsFromClientInvoice',
      JSON.stringify(removeItem)
    );
  }

  static EditMultipleLineItems(editItem) {
    return AuthService.getInstance().CallBackendFunctionPut(
      '/api/ClientLine/EditMultipleLineItemsFromClientInvoice',
      JSON.stringify(editItem)
    );
  }

  static CreateLineItem(item) {
    return AuthService.getInstance().CallBackendFunctionPost(
      '/api/ClientLine/CreateLineItemsFromClientInvoice',
      JSON.stringify(item)
    );
  }
}
